import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UnknownAction } from 'redux';
import styled from '@emotion/styled';

import { RootState } from '../../../store/rootReducer';
import { useProductsInfos } from '../../common/hooks/useProductsInfos';
import { cmsProductInit } from '../../cms/actions';
import { setCrossSellLoading } from '../actions';
import { RecommendationsBlock } from '../../recommendations/components/RecommendationsBlock';
import { loadRecommendationsHomemade } from '../../recommendations/utils';

const StyledCrossSellContainer = styled.div`
  overflow: hidden;
  margin: 0 16px;
`;

type Props = {
  mainProductRef: string;
  mainProductColorRef: string;
};

export const CrossSell = ({ mainProductRef, mainProductColorRef }: Props) => {
  const dispatch = useDispatch();
  const [recommendedRefs, setRecommendedRefs] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const { cross_sell_title: title } = useSelector((state: RootState) => state.cms.product);

  useEffect(() => {
    if (!title) {
      dispatch(cmsProductInit() as unknown as UnknownAction);
    }
  }, []);

  const { hits } = useProductsInfos(recommendedRefs);

  useEffect(() => {
    const target = document.getElementsByClassName('modal__content').item(0) as HTMLElement;

    if (
      (!loading && recommendedRefs.length > 0 && hits.length === recommendedRefs.length) ||
      (!loading && !recommendedRefs.length)
    ) {
      if (!recommendedRefs.length) {
        if (target) {
          target.classList.add('modal__without-height');
        }
      }
      dispatch(setCrossSellLoading(false));
    }

    return () => {
      if (target) {
        target.classList.remove('modal__without-height');
      }
    };
  }, [recommendedRefs, hits, loading]);

  useEffect(() => {
    const fetchRecommendations = async () => {
      try {
        setLoading(true);
        const data = await loadRecommendationsHomemade({
          type: 'product',
          params: { productRef: mainProductRef, colorRef: mainProductColorRef },
        });
        setRecommendedRefs(data.crossSell ?? []);
      } catch (e) {
        setRecommendedRefs([]);
      } finally {
        setLoading(false);
      }
    };
    fetchRecommendations();
  }, []);

  if (!recommendedRefs.length || loading) {
    return null;
  }

  return (
    <StyledCrossSellContainer>
      <RecommendationsBlock id="cross-sell" title={title} hits={hits} />
    </StyledCrossSellContainer>
  );
};
